import React, { useState } from "react";

const App = () => {
  const [url, setUrl] = useState("");
  const [iframeUrl, setIframeUrl] = useState("");
  const [height, setHeight] = useState('700px');
  const [iframeStyle, setIframeStyle] = useState({
    border: "2px solid #ccc",
    width: "100%",
    height: "100%",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setIframeUrl(url);
  };

  const handleIframeLoad = () => {
    setIframeStyle((prevStyle) => ({
      ...prevStyle,
      left: "0",
      top: "0",
      position: "relative",
    }));
  };

  return (
    <div style={{ fontFamily: "Arial, sans-serif", textAlign: "center", margin: "20px" }}>
      <h1
        style={{
          color: "#333",
          fontSize: "24px",
          fontWeight: "bold",
          marginBottom: "20px",
        }}
      >
        <span role="img" aria-label="iframe">
          🖼️
        </span>{" "}
        Frametest
      </h1>
      <form onSubmit={handleSubmit} style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
      }}>
        <div style={{ width: "100%", display: "flex", justifyContent: "start", alignItems: "center", marginBottom: "20px" }}>
          <label htmlFor="url" style={{ marginRight: "10px" }}>
            Enter URL:
          </label>
          <input
            type="text"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="Enter URL"
            style={{
              padding: "10px",
              width: "60%",
              marginRight: "10px",
              border: "1px solid #ccc",
              borderRadius: "5px",
            }}
          />
          <button
            type="submit"
            style={{
              padding: "10px 20px",
              backgroundColor: "#007BFF",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Load URL
          </button>
        </div>
        <div style={{ width: "100%", display: "flex", justifyContent: "start", alignItems: "center" }}>
          <label htmlFor="height" style={{ marginRight: "10px" }}>
            Enter Height:
          </label>
          <input
            type="text"
            value={height}
            onChange={(e) => setHeight(e.target.value)}
            placeholder="Enter Height"
            style={{
              padding: "10px",
              width: "20%",
              marginRight: "10px",
              border: "1px solid #ccc",
              borderRadius: "5px",
            }}
          />
        </div>
      </form>
      <div style={{ marginTop: "20px", border: "1px solid #ccc", height: height, overflow: "hidden", left: "0 !important", top: "0 !important", position: "relative !important" }}>
        {iframeUrl ? (
          <iframe
            src={iframeUrl}
            title="Iframe Test"
            style={iframeStyle}
            onLoad={handleIframeLoad}
          ></iframe>
        ) : (
          <p style={{ color: "#888", marginTop: "20px" }}>Enter a URL to load in the iframe</p>
        )}
      </div>
    </div>
  );
};

export default App;